<template>
  <a-modal
    title="系统更新"
    centered
    :width="800"
    :mask-closable="false"
    :visible="showBuildForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="构建类型" prop="type" :disabled="loading || !completed">
            <a-select allow-clear placeholder="请选择" v-model="model.type">
              <a-select-option value="web">WEB</a-select-option>
              <a-select-option value="api">API</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="实时日志">
            <a-textarea id="output" ref="output" placeholder="请先提交构建任务" :read-only="true" :auto-size="{ minRows: 5, maxRows: 5 }" v-model="output"/>
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :loading="!completed" :disabled="loading || !completed">开始构建</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'BuildForm';
</style>

<script>
import BuildForm from './BuildForm'
export default BuildForm
</script>
